import Investment from '../../../models/Investment';
import { GeneratedReportDetails, Report, Notes, QueuedReport } from '../types';
import { Fund } from '../../fund/types';
import { PensionScheme } from '@/modules/pensionScheme/types';
import { AnalysisPensionScheme } from '../../costAnalysis/types';
import { SubFund } from '../../subFund/types';
import TimePeriod from '../../../models/TimePeriod';
export interface IReportingState {
  loadingReportData: boolean;
  rawHtml: string;
  planType: string;
  reportSubType: string;
  isOrganisationWideExport: boolean;
  selectedReportingPeriod: TimePeriod;
  reportPensionSchemes: Fund[];
  selectedReportClient: AnalysisPensionScheme | SubFund | null;
  generatedReportDetails: GeneratedReportDetails;
  reports: Report[];
  comments: Notes[];
  exposedSubFunds: SubFund[];
  schemesHavingExposedSubFunds: PensionScheme[];
  queuedReports: QueuedReport[];
}

export const ReportingState: IReportingState = {
  loadingReportData: false,
  rawHtml: '',
  planType: '',
  reportSubType: '',
  selectedReportingPeriod: {} as TimePeriod,
  isOrganisationWideExport: false,
  reportPensionSchemes: [],
  selectedReportClient: null,
  generatedReportDetails: {} as GeneratedReportDetails,
  reports: [],
  comments: [],
  exposedSubFunds: [],
  schemesHavingExposedSubFunds: [],
  queuedReports: []
};
